/* eslint-disable max-lines */
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
  Media,
  Button,
} from 'reactstrap';
import { useContext, useState, useEffect } from 'react';
import { Context as AuthContext } from '../../../contexts/AuthContext';
import { Link, Redirect, useParams } from 'react-router-dom';
import UserService from '../../../services/User';
import CommonHeader from '../../../components/Headers/CommonHeader';
import ProfileTab from './TabContent/ProfileTab';
import TimeCardTab from './TabContent/TimeCardTab';
import EmployeeDetailsTab from './TabContent/EmployeeDetailsTab';
import ChildrenTab from './TabContent/ChildrenTab';
import MedicalTab from './TabContent/MedicalTab';
import AsideProfile from './ProfileRightBar';
import isParent from '../../../helpers/isParent';
import NotificationTab from './TabContent/NotificationTab';
import FilesTab from './TabContent/FilesTab';
import Employee from '../../../services/Employee';
import { toast } from 'react-toastify';
import moment from 'moment';
import isClassroom from '../../../helpers/isClassroom';
import ClassPermissionsTab from './TabContent/ClassPermissionsTab';
import OpacityLoaderSpinner from '../../../components/Core/OpacityLoaderSpinner';
import MessagingListTalk from '../Messaging/MessagingListTalk';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import isAdmin from '../../../helpers/isAdmin';
import { ucfirst } from '../../../helpers/string';
import { PayRatesList } from '../../../components/Employee';
import isDirector from '../../../helpers/isDirector';
import isEducationDirectorAdminAssistant from '../../../helpers/isEducationDirectorAdminAssistant';
import LogHistoryList from '../../../components/LogHistory/LogHistoryList';
import isFinanceUser from '../../../helpers/isFinanceUser';
import isHRUser from '../../../helpers/isHRUser';
import isUpperManagement from '../../../helpers/isUpperManagement';
import isAuthorized from '../../../helpers/isAuthorized';
import PerformanceManagementTab from './TabContent/PerformanceManagementTab';
import { canViewPerformanceManagement } from '../../../helpers/performanceManagementPermissions';
import isTeacher from '../../../helpers/isTeacher';
import TaskBoardService from '../../../services/TaskBoard';
import TeacherTicketModal from './TeacherTicketModal';

const Profile = () => {
  const { isMobile } = useCheckMobileScreen();
  const { id: userIdConst, tabToOpen } = useParams<{ id: string; tabToOpen?: string }>();

  let userId = userIdConst;

  const { token, user: loggedUser, currentSchool, appVersion }: any = useContext(AuthContext);
  if (!userId && loggedUser?.id) {
    userId = loggedUser?.id;
  }
  const [kidsList, setKidsList] = useState([]);
  const [reload, setReload] = useState(false);
  const [currentUser, setCurrentUser] = useState({} as any);
  const [terminationDateDay, setTerminationDateDay] = useState('');
  const [terminationDateMonth, setTerminationDateMonth] = useState('');
  const [terminationDateYear, setTerminationDateYear] = useState('');
  const [isTerminationFuture, setIsTerminationFuture] = useState(false);
  const [isParentUser, setIsParentUser] = useState(false);
  const [isUserHimself, setIsUserHimself] = useState(false);
  const [isClassroomUser, setIsClassroomUser] = useState<boolean | null>(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [activeTab, setActiveTab] = useState('');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [tabsLoaded, setTabsLoaded] = useState<Record<string, boolean>>({});
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [ticketSaving, setTicketSaving] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    if (!tabsLoaded[tab]) {
      setTabsLoaded((prev) => ({ ...prev, [tab]: true }));
    }
  };

  const isMediumScreen = windowWidth <= 834 && windowWidth > 768;
  const isSmallScreen = windowWidth <= 768 || isMobile;

  const [currSchoolWhenStart, _] = useState(currentSchool);
  const [redirctToList, setRedirctToList] = useState(false);
  useEffect(() => {
    if (currentSchool && currentSchool !== currSchoolWhenStart && (isAdmin(loggedUser) || isDirector(loggedUser)))
      setRedirctToList(true);
  }, [currentSchool, currSchoolWhenStart]);

  useEffect(() => {
    if (!userId) return;
    getKidsByUserId();
    getUserById();
    if (tabToOpen) setActiveTab(tabToOpen);
  }, []);

  useEffect(() => {
    if (!userId) return;
    getKidsByUserId();
    getUserById();
    setIsUserHimself(userId === loggedUser.id);
  }, [userId]);

  useEffect(() => {
    setLoadingUser(true);
    if (Object.keys(currentUser).length === 0 && currentUser.constructor === Object) {
      return;
    }
    setIsParentUser(isParent(currentUser));
    setIsClassroomUser(isClassroom(currentUser));
    setLoadingUser(false);
  }, [currentUser]);

  useEffect(() => {
    if (isClassroomUser === null) {
      return;
    }
    let tab = tabToOpen || 'profile';
    if (isClassroomUser) {
      tab = 'classes';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const initialTab = urlParams.get('tab') || tab;
    setActiveTab(initialTab);
    setTabsLoaded((prev) => ({ ...prev, [initialTab]: true }));
  }, [isClassroomUser]);

  const getKidsByUserId = async () => {
    if (!userId) return;
    try {
      const result = await UserService(token).listKids(userId);
      setKidsList(result?.data || []);
    } catch (e: any) {
      console.error(e?.response?.data?.message || 'Invalid user ID');
    }
  };

  const getUserById = async () => {
    if (!userId) return;
    try {
      const result = await UserService(token).show(userId);
      setCurrentUser(result?.data || {});
      if (result?.data?.employee?.terminationDate) {
        const terminationDate = moment(result?.data?.employee?.terminationDate);
        setTerminationDateDay(terminationDate?.format('Do'));
        setTerminationDateMonth(terminationDate?.format('MMMM'));
        setTerminationDateYear(terminationDate?.format('YYYY'));
        setIsTerminationFuture(terminationDate >= moment(moment().format('YYYY-MM-DD')));
      }
    } catch (e: any) {
      console.error(e?.response?.data?.message || 'Invalid user ID');
    }
  };

  const customStyles = {
    navLink: {
      minHeight: '42px',
      paddingTop: '8px',
    },
  };

  const visibleChildrenTab = kidsList?.length;

  const handleActivatedEmployee = async (employeeId: string) => {
    if (!employeeId) return;
    try {
      await Employee(token).activated(employeeId);
      getUserById();
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Is not possible change status!');
    }
  };

  const userTabs = {
    profile: {
      content: <ProfileTab refresh={getUserById} />,
      name: 'Profile',
      icon: 'fas fa fa-user',
      visible: !isClassroomUser,
    },
    time:
      appVersion === 'HR' && !isAdmin(loggedUser)
        ? undefined
        : {
            content: <TimeCardTab />,
            name: 'Time Card',
            icon: 'fas fa fa-clock',
            visible: !isParentUser && currentUser?.employee?.id,
          },
    employee: {
      content: <EmployeeDetailsTab />,
      name: `Employee${!isMobile ? ' Details' : ''}`,
      icon: 'fas fa fa-briefcase',
      visible: !isParentUser && !isClassroomUser,
    },
    children: {
      content: <ChildrenTab />,
      name: `Children`,
      icon: 'fas fa fa-child',
      visible: !!visibleChildrenTab,
    },
    medical: {
      content: <MedicalTab />,
      name: `Medical`,
      icon: 'fas fa-notes-medical',
      visible: !isParentUser && !isClassroomUser,
    },
    notifications: {
      content: <NotificationTab />,
      name: `Notifications`,
      icon: 'fas fa-bell',
      visible: false,
    },
    files: {
      content: <FilesTab reload={reload} />,
      name: `Files`,
      icon: 'fas fa-file',
      visible:
        isHRUser(loggedUser) ||
        isUpperManagement(loggedUser) ||
        isAdmin(loggedUser) ||
        isFinanceUser(loggedUser) ||
        isDirector(loggedUser) ||
        userId === loggedUser?.id,
    },
    classes: {
      content: <ClassPermissionsTab userId={currentUser?.id} />,
      name: `Classes`,
      icon: 'fas fa-lock',
      visible: isClassroomUser,
    },
    messages: {
      content: <MessagingListTalk userId={userId} />,
      name: `Messages`,
      icon: 'fas fa-comment',
      visible: isAdmin(loggedUser),
    },
    payrates: {
      content: <PayRatesList employeeId={currentUser?.employee?.id} />,
      name: `Pay Rates`,
      icon: 'fas fa-money-bill-wave',
      visible:
        isUpperManagement(loggedUser) || isAdmin(loggedUser) || isFinanceUser(loggedUser) || isDirector(loggedUser),
    },
    history: {
      content: <LogHistoryList entityId={currentUser?.employee?.id} entity="Employee" />,
      name: `History`,
      icon: 'fas fa-history',
      visible: isAdmin(loggedUser),
    },
    performance: {
      content: <PerformanceManagementTab userId={currentUser?.id} />,
      name: `Performance Management`,
      icon: 'fas fa-chart-line',
      visible:
        canViewPerformanceManagement(loggedUser) &&
        (isAdmin(loggedUser) || String(currentUser?.id) !== String(loggedUser?.id)) &&
        !(
          isEducationDirectorAdminAssistant(loggedUser) &&
          (isDirector(currentUser) || isEducationDirectorAdminAssistant(currentUser))
        ),
    },
  };

  const getTabName = (tabKey: string) => {
    return (userTabs as any)[tabKey]?.name || ucfirst(tabKey);
  };

  const isVisible = (tabKey: string) => {
    return (userTabs as any)[tabKey]?.visible;
  };

  const openTicketModal = () => {
    setTicketModalOpen(true);
  };

  const handleCreateTeacherTicket = async (payload: {
    teacherName: string;
    date: string;
    classroomNumber: string;
    ticketType: 'supplies' | 'one_on_one' | 'labels' | 'monthly_curriculum_event' | 'request' | 'mealtime_check';
    suppliesData?: { whatNeed?: string; howMuchNeed?: string; whatFor?: string; needByDate?: string };
    oneOnOneData?: {
      notes?: string;
      meetingWith?: 'any_manager' | 'director' | 'education_director' | 'administrative_assistant';
    };
    monthlyExtrasData?: { month?: string; activities?: string };
    requestText?: string;
    mealtimeCheck?: boolean;
  }) => {
    const schoolId = currentUser?.employee?.schoolId || currentSchool?.value;
    if (!schoolId) {
      toast.error('School not found for this user.');
      return;
    }
    setTicketSaving(true);
    try {
      await TaskBoardService(token).createTeacherTicket(schoolId, payload);
      setTicketModalOpen(false);
      toast.success('Ticket sent successfully.');
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Could not send ticket.');
    } finally {
      setTicketSaving(false);
    }
  };

  const terminationPaperworkUrl =
    (currentUser?.employee?.terminationDetails || [])
      .filter((t: any) => t?.signedDocumentUrl)
      .sort((a: any, b: any) => new Date(b?.createdAt || 0).getTime() - new Date(a?.createdAt || 0).getTime())[0]
      ?.signedDocumentUrl || null;

  return (
    <>
      {redirctToList ? <Redirect to={'/directory'} /> : <></>}
      <CommonHeader />
      {loadingUser ? <OpacityLoaderSpinner /> : <></>}
      <Container className="mt--8" fluid style={loadingUser ? { display: 'none' } : { display: 'block' }}>
        <Row>
          <Col className="order-xl-2" xl="12" style={isMobile ? { paddingLeft: 5, paddingRight: 5 } : {}}>
            <Card className="bg-secondary shadow">
              {currentUser?.status === 'TERMINATED' ? (
                <Alert color="warning" className="mt-1 ml-1 mr-1">
                  <b>Terminated:</b> {currentUser?.firstName}'s last day of work {isTerminationFuture ? 'is' : 'was'}{' '}
                  {terminationDateMonth || ''} {terminationDateDay || ''}, {terminationDateYear || ''}.{' '}
                  {isAuthorized({ moduleName: 'EmployeeTerminate', functionName: 'Revoke' }, loggedUser) && (
                    <>
                      <Link
                        to={`/directory?id=${currentUser?.employee?.id}&type=revoke`}
                        className="text-white"
                        style={{ textDecoration: 'underline white' }}
                      >
                        <b>Revoke Termination</b>
                      </Link>
                      {' | '}
                    </>
                  )}
                  <Link
                    to={`/directory?id=${currentUser?.employee?.id}&type=rehire`}
                    className="text-white"
                    style={{ textDecoration: 'underline white' }}
                  >
                    <b>Rehire</b>
                  </Link>
                  {terminationPaperworkUrl && (
                    <>
                      {' | '}
                      <a
                        href={terminationPaperworkUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-white"
                        style={{ textDecoration: 'underline white' }}
                      >
                        <b>Termination Paperwork</b>
                      </a>
                    </>
                  )}
                </Alert>
              ) : (
                <></>
              )}
              <CardHeader
                className="bg-white border-0 mb-0 pb-0"
                style={
                  isSmallScreen
                    ? { padding: '1rem 0.5rem', paddingBottom: '10px' }
                    : isMediumScreen
                    ? { paddingBottom: '20px' }
                    : {}
                }
              >
                <div style={{ marginBottom: '12px' }}>
                  <Media className="align-items-center">
                    <span className="avatar rounded-circle" style={{ width: '60px', height: '60px' }}>
                      <img
                        alt={`${currentUser?.firstName} ${currentUser?.lastName}`}
                        src={
                          currentUser?.picture
                            ? `${currentUser?.picture}`
                            : require('../../../assets/img/user-default.png').default
                        }
                        style={{ height: '100%' }}
                      />
                    </span>
                    <Media className="ml-2">
                      <span className="mb-0 text-sm font-weight-bold">{`${currentUser?.firstName} ${currentUser?.lastName}`}</span>
                    </Media>
                    {isTeacher(currentUser) && (
                      <Button color="primary" size="sm" className="ml-auto" onClick={openTicketModal}>
                        Ticket
                      </Button>
                    )}
                  </Media>
                </div>
                <div
                  className="tabs-thin-scroll"
                  style={{
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    WebkitOverflowScrolling: 'touch',
                    whiteSpace: 'nowrap',
                    marginBottom: isSmallScreen ? '5px' : isMediumScreen ? '15px' : '0',
                  }}
                >
                  <Nav
                    className="border-0 nav-profile"
                    tabs
                    style={{
                      flexWrap: 'nowrap',
                      display: 'flex',
                    }}
                  >
                    {Object.keys(userTabs).map((tab: string, i: number) => (
                      <>
                        {isVisible(tab) && (
                          <NavItem
                            className="cursor-pointer"
                            key={`nav-item_${i}`}
                            style={{
                              flexShrink: 0,
                              minWidth: 'fit-content',
                            }}
                          >
                            <NavLink
                              className="border-0 cursor-pointer font-weight-bold nav-link-profile"
                              style={customStyles.navLink}
                              active={activeTab === tab}
                              onClick={() => handleTabChange(tab)}
                            >
                              <i className={`${(userTabs as any)[tab]?.icon} ${!isSmallScreen ? 'mr-2' : ''}`} />
                              <span>{getTabName(tab)}</span>
                            </NavLink>
                          </NavItem>
                        )}
                      </>
                    ))}
                  </Nav>
                </div>
              </CardHeader>
              <CardBody className="d-flex flex-wrap w-100">
                <Col xl="8" lg="8" md="12">
                  <TabContent activeTab={activeTab}>
                    {Object.keys(userTabs).map((tab: string, i: number) => (
                      <TabPane key={`tab-pane_${i}`} tabId={tab}>
                        {isVisible(tab) && tabsLoaded[tab] && (userTabs as any)[tab].content}
                      </TabPane>
                    ))}
                  </TabContent>
                </Col>
                <Col xl="4" lg="4" md="12">
                  <AsideProfile
                    reload={reload}
                    handleReload={setReload}
                    currentUser={currentUser}
                    isUserHimself={isUserHimself}
                    handleActivatedEmployee={handleActivatedEmployee}
                  />
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <TeacherTicketModal
        isOpen={ticketModalOpen}
        teacherName={`${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`.trim()}
        saving={ticketSaving}
        onClose={() => setTicketModalOpen(false)}
        onSubmit={handleCreateTeacherTicket}
      />
    </>
  );
};

export default Profile;
